import { ReactElement, ElementType, useMemo } from 'react';

import { DashboardVariantV2CarrierContextTabId } from '../../types';
import { useDashboardVariantV2CarrierContext } from '../../Context';

import DashboardVariantV2CarrierContentCollectTab from './Collect';
import DashboardVariantV2CarrierContenInWarehouseTab from './InWarehouse';
import DashboardVariantV2CarrierContentInTransitTab from './InTransit';
import DashboardVariantV2CarrierContentFinalizedTab from './Finalized';

const TABS_COMPONENTS: Record<
  DashboardVariantV2CarrierContextTabId,
  ElementType
> = {
  collect: DashboardVariantV2CarrierContentCollectTab,
  inWarehouse: DashboardVariantV2CarrierContenInWarehouseTab,
  inTransit: DashboardVariantV2CarrierContentInTransitTab,
  finalized: DashboardVariantV2CarrierContentFinalizedTab,
};

const DashboardVariantV2CarrierContentTabs = (): ReactElement => {
  const {
    activeTab: { currentTab },
  } = useDashboardVariantV2CarrierContext();

  const TabComponent = useMemo(() => TABS_COMPONENTS[currentTab], [currentTab]);

  return <TabComponent />;
};

export default DashboardVariantV2CarrierContentTabs;
